import React from 'react';
import styles from './styles.module.scss';
import Logo from '../../logos/logo_web_secondary.png';
//import { useNavigate } from 'react-router';

export default function DesktopHeader() {

  // const navigate = useNavigate();

  // const redirect = (href) => {
  //   navigate(href);
  // };

  const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 80; // 80px offset
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

  return (
    <div className={styles.deskHeader}>
      <div className={`${styles.deskPanel} reg-round p-4 col-11 col-lg-8 col-xl-6 mt-3`}>
        <nav className={`${styles.deskNavbar} d-flex align-items-center justify-content-between`}>
          <div className={`${styles.navGroup} col-4 col-lg-3 d-flex align-items-center justify-content-between`}>
            <div className={styles.deskNavLink} onClick={() => scrollToSection('tilbyr')}>Hva vi tilbyr</div>
            <div className={styles.deskNavLink} onClick={() => scrollToSection('kontakt')}>Kontakt</div>
            <div className={styles.deskNavLink} onClick={() => scrollToSection('FAQ')}>FAQ's</div>
          </div>
          <div onClick={() => scrollToSection('top')} className={`${styles.deskMiddle} col-4 d-flex justify-content-center`}>
            <img src={Logo} alt="Logo" className="img-fluid col-lg-11 pb-lg-1" />
          </div>
           <div className={`${styles.navGroup} col-4 col-lg-3 d-flex align-items-center justify-content-between`}>
            
            <div className={styles.deskNavLink} onClick={() => scrollToSection('kundeomtaler')}>Omtaler</div>
            <div className={styles.deskNavLink} onClick={() => scrollToSection('how')}>Metode</div>
            <div className={styles.deskNavLink} onClick={() => scrollToSection('tools')}>Verktøy</div>
          </div>
        </nav>
      </div>
    </div>
  );
}
